function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Match from './Match';
import MatchOptions from './MatchOptions';
import * as Utils from './Utils';

function putNewWord(block, word, blockSize) {
  block.push(word);

  if (block.length > blockSize) {
    block.shift();
  }

  if (block.length !== blockSize) {
    return null;
  }

  return block.join('');
} // Finds the longest match in given texts. It uses indexing with fixed granularity that is used to compare blocks of text.


var MatchFinder =
/*#__PURE__*/
function () {
  function MatchFinder(oldWords, newWords, startInOld, endInOld, startInNew, endInNew, options) {
    _classCallCheck(this, MatchFinder);

    this.oldWords = oldWords;
    this.newWords = newWords;
    this.startInOld = startInOld;
    this.endInOld = endInOld;
    this.startInNew = startInNew;
    this.endInNew = endInNew;
    this.options = options;
  }

  _createClass(MatchFinder, [{
    key: "indexNewWords",
    value: function indexNewWords() {
      this.wordIndices = new Map();
      var block = [];

      for (var i = this.startInNew; i < this.endInNew; i++) {
        // if word is a tag, we should ignore attributes as attribute changes are not supported (yet)
        var word = this.normalizeForIndex(this.newWords[i]);
        var key = putNewWord(block, word, this.options.blockSize);

        if (key === null) {
          continue;
        }

        if (this.wordIndices.has(key)) {
          this.wordIndices.get(key).push(i);
        } else {
          this.wordIndices.set(key, [i]);
        }
      }
    } // Converts the word to index-friendly value so it can be compared with other similar words

  }, {
    key: "normalizeForIndex",
    value: function normalizeForIndex(word) {
      word = Utils.stripAnyAttributes(word);

      if (this.options.IgnoreWhiteSpaceDifferences && Utils.isWhiteSpace(word)) {
        return ' ';
      }

      return word;
    }
  }, {
    key: "findMatch",
    value: function findMatch() {
      this.indexNewWords();
      this.removeRepeatingWords();

      if (this.wordIndices.length === 0) {
        return null;
      }

      var bestMatchInOld = this.startInOld;
      var bestMatchInNew = this.startInNew;
      var bestMatchSize = 0;
      var matchLengthAt = new Map();
      var blockSize = this.options.blockSize;
      var block = [];

      for (var indexInOld = this.startInOld; indexInOld < this.endInOld; indexInOld++) {
        var word = this.normalizeForIndex(this.oldWords[indexInOld]);
        var index = putNewWord(block, word, blockSize);

        if (index === null) {
          continue;
        }

        var newMatchLengthAt = new Map();

        if (!this.wordIndices.has(index)) {
          matchLengthAt = newMatchLengthAt;
          continue;
        }

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.wordIndices.get(index)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var indexInNew = _step.value;
            var newMatchLength = (matchLengthAt.has(indexInNew - 1) ? matchLengthAt.get(indexInNew - 1) : 0) + 1;
            newMatchLengthAt.set(indexInNew, newMatchLength);

            if (newMatchLength > bestMatchSize) {
              bestMatchInOld = indexInOld - newMatchLength - blockSize + 2;
              bestMatchInNew = indexInNew - newMatchLength - blockSize + 2;
              bestMatchSize = newMatchLength;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        matchLengthAt = newMatchLengthAt;
      }

      return bestMatchSize !== 0 ? new Match(bestMatchInOld, bestMatchInNew, bestMatchSize + blockSize - 1) : null;
    } // This method removes words that occur too many times. This way it reduces total count of comparison operations
    // and as result the diff algoritm takes less time. But the side effect is that it may detect false differences of
    // the repeating words.

  }, {
    key: "removeRepeatingWords",
    value: function removeRepeatingWords() {
      var threshold = this.newWords.length + this.options.repeatingWordsAccuracy;
      var repeatingWords = Array.from(this.wordIndices.entries()).filter(function (i) {
        return i[1].length > threshold;
      }).map(function (i) {
        return i[0];
      });
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = repeatingWords[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var w = _step2.value;
          this.wordIndices["delete"](w);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }]);

  return MatchFinder;
}();

export { MatchFinder as default };